export const strings = {
  sidebar: {
    title: 'CareSurround',
    subtitle: 'Global Admin Console',
    groups: {
      tooltip: 'See and set up groups',
    },
    units: {
      tooltip: 'See units from all groups',
    },
    devices: {
      tooltip: 'Track all devices and reassign them',
    },
    policies: {
      tooltip: 'View and change organisation policies',
    },
    users: {
      tooltip: 'Manage users in your organisation',
    },
    dashboard: {
      tooltip: 'See connectivity data for your devices',
    },
  },
  importing: {
    title: 'Import devices',
    subtitle: 'Add devices from ASP to the CareSurround platform',
  },
  dashboard: {
    title: 'DASHBOARD',
    subtitle: 'Connectivity Information',
    tooltip: 'Readings are taken of online/offline devices every 5 minutes',
  },
  devices: {
    title: 'DEVICES',
    subtitlePrefix: 'Platform',
    subtitleTooltip: 'Device',
    subtitlePostfix: 'Management',
    organisation: {
      tooltip:
        'Devices can be managed here. Assign them to units before using them.',
    },
    platform: {
      tooltip:
        'Devices can be managed here. Assign them to organisations so they can view them.',
    },
    drawer_assign: {
      title: 'Assign Device(s)',
      subtitle:
        'Choose the organisation the selected devices should associate with',
      submit: 'Save',
      cancel: 'Cancel',
    },
    drawer_associate: {
      title: 'Associate Device(s)',
      subtitle: 'Choose the unit the selected devices should associate with',
      submit: 'Save',
      cancel: 'Cancel',
    },
    drawer_view: {
      title: 'Manage Device',
      unlink_organisation: 'Unassign device',
      unlink_unit: 'Unassociate device',
      delete: 'Delete device',
      close: 'Close',
    },
    drawer_announce: {
      submit: 'Send',
      cancel: 'Cancel',
    },
    modal_confirm_unassign: {
      title: 'Unassign device(s)?',
      description:
        'Are you sure you want to unassign the selected devices from their organisation?',
      cancel: 'Cancel',
      unassign: 'Unassign',
    },
    modal_confirm_unassociate: {
      title: 'Unassociate device(s)?',
      description:
        'Are you sure you want to unassociate the device from this unit?',
      cancel: 'Cancel',
      unassociate: 'Unassociate',
    },
    modal_confirm_delete: {
      title: 'Delete device?',
      description:
        'Are you sure you want to delete this device? This action cannot be undone.',
      cancel: 'Cancel',
      delete: 'Delete',
    },
  },
  organisations: {
    title: 'ORGANISATIONS',
    subtitle: 'Care Providers',
    drawer_create_form: {
      title: 'Create New Organisation',
      subtitle:
        'Add a new care provider to the platform by naming the organisation.',
      submit: 'Create Organisation',
      cancel: 'Cancel',
    },
    drawer_edit_form: {
      title: 'Edit Organisation',
      submit: 'Save',
      cancel: 'Cancel',
      disable: 'Disable organisation',
    },
    drawer_view: {
      title: 'Manage Organisation',
      edit: 'Edit',
      disable: 'Disable organisation',
    },
    modal_confirm_delete: {
      title: 'Disable organisation?',
      description:
        'Are you sure you want to disable this organisation? Disabling this organisation will restrict all users associated with it from accessing the platform, and all devices and services will be temporarily paused.',
      cancel: 'Cancel',
      disable: 'Disable',
    },
  },
  policies: {
    platform: {
      title: 'POLICIES',
      subtitlePrefix: 'Platform Policy Management',
      organisation: {
        title: 'POLICY SETTINGS',
      },
    },
    organisation: {
      title: 'POLICIES',
      subtitlePrefix: 'Default Organisation',
      subtitleTooltip: 'Policy',
      tooltip: 'Policies determine how units in your organisation act',
      breadcrumbs: {
        title_key: 'ORGANISATION_NAME',
      },
    },
    subtitle: {},
    section: {
      addressBookSettings: {
        title: 'Address Book settings',
        description:
          'Configure the name users see when getting calls and add helpline numbers.',
        fields: {
          enable_automated_checks: {
            label: 'Automated wellbeing check',
            description:
              'Automatically check in on the care receiver to monitor their well-being.',
          },
          frequency: {
            label: 'Frequency of sending wellbeing checks:',
          },
        },
      },
      wellbeingCheckSettings: {
        title: 'Wellbeing check settings',
        description:
          "Configure automated check-ins to monitor residents' wellbeing on a regular basis.",
        fields: {
          enable_automated_checks: {
            label: 'Automated wellbeing check',
            description:
              'Automatically check in on the care receiver to monitor their well-being.',
          },
          frequency: {
            label: 'Frequency of sending wellbeing checks:',
          },
        },
      },
      responseAction: {
        title: 'Response Actions',
        description:
          "Set the actions to be triggered based on the resident's wellbeing check response.",
        fieldset: {
          positive_response: {
            title: 'Positive response',
            description:
              'Choose the action when the resident gives a positive response.',
          },
          negative_response_with_help: {
            title: 'Negative response **with** request for help',
            description:
              'Choose the action when the resident requests help with a negative response.',
          },
          negative_response_without_help: {
            title: 'Negative response **without** request for help',
            description:
              'Choose the action when the resident gives a negative response but does not request help.',
            fields: {
              instancesBeforeAction: {
                label: 'Number of instances before taking action:',
              },
            },
          },
          no_response: {
            title: 'No response',
            description:
              'Set how long to wait before triggering an action if there is no response.',
            fields: {
              waitTimeMinutes: {
                label: 'Time elapsed before taking action:',
              },
            },
          },
        },
      },
      skills: {
        title: 'Skills enabled',
        description: {
          platform:
            'A list of all the alexa skills enabled for this organisation.',
          organisation:
            'A list of all the alexa skills enabled in your organisation.',
        },
      },
      accessibility: {
        title: 'Device accessibility settings',
        description:
          'Customise accessibility features to enhance the user experience based on individual needs.',
        fields: {
          closed_captioning: {
            label: 'Closed captioning',
            description: 'Enable or disable closed captions for video content.',
          },
          magnifier: {
            label: 'Magnifier',
            description: 'Enable screen magnification for easier readability.',
          },
          speaking_rate: {
            label: 'Speaking rate',
            description: `Adjust the speed at which spoken content is delivered. Choose a rate that suits the user's listening preference.`,
          },
        },
      },
    },
  },
  groups: {
    title: 'GROUPS',
    tooltip:
      'Groups are used to organise units - this could be by area, by care pattern, etc.',
  },
  group: {
    title: 'GROUP',
  },
  new_unit: {
    title: 'UNIT SETUP',
    subtitle: 'Add a new unit',
  },
  unit: {
    title: 'UNIT NAME',
    breadcrumbs: {
      title_key: 'UNIT_NAME',
    },
    residents: {
      drawer_view: {
        title: 'Manage Resident',
        unlink_unit: 'Unassociate resident',
        close: 'Close',
      },
    },
  },
  users: {
    title: 'USERS',
    subtitlePrefix: 'Platform',
    subtitleTooltip: 'User',
    subtitlePostfix: 'Management',
    tooltip: 'Users can perform actions based on their roles',
    drawer_create_form: {
      title: 'Create User',
      submit: 'Create User',
      cancel: 'Cancel',
    },
    drawer_edit_form: {
      title: 'Edit User',
      submit: 'Save',
      cancel: 'Cancel',
      delete: 'Delete user',
    },
    drawer_view: {
      title: 'Manage User',
      close: 'Close',
      edit: 'Edit',
    },
    modal_confirm_delete: {
      title: 'Delete account?',
      description:
        'Are you sure you want to delete this account? Deleting this account is an irreversible action.',
      cancel: 'Cancel',
      delete: 'Delete',
    },
  },
  wellbeing_responses: {
    title: 'Resident wellbeing responses',
    subtitle:
      'View and track the latest wellbeing check responses for each resident.',
    empty: 'There are no responses to display',
    no_response: 'No Response',
    positive_response: 'Positive Response',
    negative_no_help_response: 'Negative response', //Currently the only negative response
    negative_with_help_response: 'Negative response with request for help', //CURRENTLY UNUSED
    unhandled_response: 'Response not handled',
  },
  notification_responses: {
    title: 'Notification responses',
    subtitle:
      'View and track the latest responses to notifications sent to residents.',
    empty: 'There are no responses to display',
    no_response: 'No Response',
    positive_response: 'Positive Response',
    negative_no_help_response: 'Negative response', //Currently the only negative response
    negative_with_help_response: 'Negative response with request for help', //CURRENTLY UNUSED
    unhandled_response: 'Response not handled',
  },
  calls: {
    title: 'Past calls to resident',
    subtitle: 'View and track the calls made to the resident of this unit.',
    empty: 'There are no calls to display',
    placed: 'Not picked up by resident',
    opened: 'Picked up by resident, but no hangup information',
    terminated: 'Call completed',
    endedBy: {
      device: 'Hung up by resident',
      dmp: 'Hung up by DMP user',
    },
  },
};
